import { useEffect, useState } from "react";

function Preloader({ onFinish }) {
  const [hide, setHide] = useState(false);
  const [progress, setProgress] = useState(0);
  const [exit, setExit] = useState(false);

  const text = "PRINTEZZ";

  useEffect(() => {
    const duration = 1800; 
    const intervalTime = duration / 100;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);

          
          setExit(true);

          
          setTimeout(() => {
            setHide(true);
            setTimeout(() => {
              onFinish();
            }, 500);
          }, 600);

          return 100;
        }
        return prev + 1; 
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 bg-black flex flex-col items-center justify-center z-[9999]
      transition-all duration-700 ease-[cubic-bezier(0.76,0,0.24,1)]
      ${hide ? "opacity-0 scale-110 blur-xl" : "opacity-100"}`}
    >
      {/* NOISE */}
      <div className="absolute inset-0 opacity-[0.04] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]"></div>

      {/* GLOW */}
      <div className="absolute w-[90vw] h-[90vw] md:w-[60vw] md:h-[60vw] bg-green-500/10 blur-[120px] rounded-full animate-pulse"></div>

      {/* TEXT */}
      <div className="relative z-10 flex flex-col items-center">
        <h1 className="text-3xl sm:text-5xl md:text-8xl font-black tracking-[0.15em] text-white flex gap-1 sm:gap-2">

          {text.split("").map((letter, i) => {
            const reverseIndex = text.length - i;

            return (
              <span
                key={i}
                className={`
                  transition-all duration-700 ease-[cubic-bezier(0.76,0,0.24,1)]
                  ${exit ? "opacity-0 -translate-y-[150px] scale-75" : ""}
                `}
                style={{
                  transitionDelay: exit
                    ? `${reverseIndex * 0.05}s`
                    : `${i * 0.07}s`,
                }}
              >
                {letter}
              </span>
            );
          })}

          {/* DOT */}
          <span
            className={`text-green-400 transition-all duration-700
            ${exit ? "opacity-0 -translate-y-[150px]" : "animate-pulse"}`}
          >
            .
          </span>
        </h1>

        {/* ⚡ PROGRESS */}
        <div className="w-[160px] sm:w-[220px] md:w-[320px] h-[2px] bg-white/10 mt-6 overflow-hidden relative">
          <div
            className="h-full bg-green-400 shadow-[0_0_8px_#4ade80]"
            style={{
              width: `${progress}%`,
              transition: "width 0.05s linear",
            }}
          ></div>
        </div>

        {/*  TEXT */}
        <div className="w-[160px] sm:w-[220px] md:w-[320px] flex justify-between mt-2 text-[10px] sm:text-xs tracking-[0.2em] text-gray-500">
          <span>INITIALIZING</span>
          <span className="text-green-400">{progress}%</span>
        </div>
      </div>
    </div>
  );
}

export default Preloader;